$(function () {
  const element = document.getElementById('checkoutModal')

  if (!element) {
    return
  }

  const modal = bootstrap.Modal.getOrCreateInstance(element)
  const methods = Array.from(element.querySelectorAll('.pay-method'))
  const receivedInput = document.getElementById('checkoutReceived')
  const referenceInput = document.getElementById('checkoutReference')
  const confirmButton = document.getElementById('checkoutConfirm')
  const text = (id, value) => (document.getElementById(id).textContent = value)
  const money = value => (Math.round(value * 100) / 100).toFixed(2)
  let config = null
  let total = 0
  let method = null

  const parseAmount = value => {
    const number = parseFloat(String(value || '').replace(/,/g, ''))
    return Number.isFinite(number) ? number : 0
  }

  const isCash = () => method?.dataset.cash === '1'
  const needsReference = () => method?.dataset.reference === '1'
  const received = () => (isCash() ? parseAmount(receivedInput.value) : total)

  function clearErrors() {
    text('checkoutReceivedError', '')
    text('checkoutReferenceError', '')
    receivedInput.classList.remove('is-invalid')
    referenceInput.classList.remove('is-invalid')
  }

  function showError(input, errorId, message) {
    input.classList.add('is-invalid')
    text(errorId, message)
    input.focus()
  }

  function refreshSummary() {
    const paid = received()
    text('checkoutSummaryReceived', money(paid))
    text('checkoutChange', money(Math.max(paid - total, 0)))
    text('checkoutMethodName', method?.dataset.name || '-')
  }

  function selectMethod(button) {
    method = button
    methods.forEach(item => {
      item.classList.toggle('active', item === button)
      item.setAttribute('aria-checked', item === button ? 'true' : 'false')
    })
    document.getElementById('checkoutCashSection').classList.toggle('d-none', !isCash())
    document.getElementById('checkoutReferenceSection').classList.toggle('d-none', !needsReference())
    document
      .getElementById('checkoutNoInputSection')
      .classList.toggle('d-none', !button || isCash() || needsReference())
    clearErrors()
    refreshSummary()
    if (isCash()) receivedInput.focus()
    if (needsReference()) referenceInput.focus()
  }

  function renderDetails(details) {
    const container = document.getElementById('checkoutDetails')
    container.innerHTML = ''
    details.forEach((detail, index) => {
      const label = document.createElement('label')
      label.className = 'form-label'
      label.textContent = detail.label
      const input = document.createElement('input')
      input.type = 'text'
      input.readOnly = true
      input.className = 'form-control' + (index < details.length - 1 ? ' mb-2' : '')
      input.value = detail.value || '-'
      container.append(label, input)
    })
  }

  function renderItems(items) {
    const list = document.getElementById('checkoutItems')
    list.innerHTML = ''
    items.forEach(item => {
      const row = document.createElement('li')
      row.className = 'd-flex justify-content-between gap-2'
      const label = document.createElement('span')
      label.textContent = item.label
      const amount = document.createElement('span')
      amount.className = 'text-nowrap'
      amount.textContent = `S/ ${money(item.amount)}`
      row.append(label, amount)
      list.appendChild(row)
    })
    text('checkoutItemsCount', `${items.length} ${config.itemsLabel || 'concepto(s)'}`)
  }

  methods.forEach(button => button.addEventListener('click', () => selectMethod(button)))

  receivedInput.addEventListener('input', () => {
    clearErrors()
    refreshSummary()
  })
  referenceInput.addEventListener('input', clearErrors)

  element.querySelector('[data-checkout-exact]').addEventListener('click', () => {
    receivedInput.value = money(total)
    clearErrors()
    refreshSummary()
  })

  element.querySelectorAll('[data-checkout-add]').forEach(button =>
    button.addEventListener('click', () => {
      receivedInput.value = money(parseAmount(receivedInput.value) + Number(button.dataset.checkoutAdd))
      clearErrors()
      refreshSummary()
    })
  )

  element.addEventListener('shown.bs.modal', () => {
    if (isCash()) receivedInput.select()
  })

  confirmButton.addEventListener('click', function () {
    clearErrors()

    if (!method) {
      Swal.fire('Método de pago', 'Seleccione el método de pago.', 'warning')
      return
    }

    if (isCash() && received() < total - 0.001) {
      showError(receivedInput, 'checkoutReceivedError', `El monto recibido debe ser al menos S/ ${money(total)}.`)
      return
    }

    if (needsReference() && !referenceInput.value.trim()) {
      showError(referenceInput, 'checkoutReferenceError', 'Ingrese el N° de operación.')
      return
    }

    confirmButton.disabled = true

    config
      .submit({
        payment_method_id: method.dataset.id,
        payment_reference: needsReference() ? referenceInput.value.trim() : '',
        amount_received: isCash() ? money(received()) : ''
      })
      .done(response => {
        modal.hide()
        if (config.onSuccess) {
          config.onSuccess(response)
          return
        }
        Swal.fire({
          text: response.message,
          icon: 'success',
          showDenyButton: Boolean(response.receipt_url),
          confirmButtonText: 'Aceptar',
          denyButtonText: 'Imprimir comprobante',
          confirmButtonColor: '#05a34a',
          denyButtonColor: '#6571ff',
          allowOutsideClick: false
        }).then(result => {
          if (result.isDenied) {
            window.open(response.receipt_url, '_blank')
          }
          window.location.reload()
        })
      })
      .fail(xhr => {
        const errors = xhr.responseJSON?.errors || {}
        if (errors.payment_reference) {
          showError(referenceInput, 'checkoutReferenceError', errors.payment_reference[0])
        } else if (errors.amount_received) {
          showError(receivedInput, 'checkoutReceivedError', errors.amount_received[0])
        } else {
          Swal.fire('Error', xhr.responseJSON?.message ?? 'No se pudo registrar el pago', 'error')
        }
      })
      .always(() => {
        confirmButton.disabled = false
      })
  })

  window.checkout = {
    open(options) {
      config = options
      total = options.total
      element.querySelector('.modal-title').textContent = options.title || 'Cobrar'
      text('checkoutTotal', money(total))
      text('checkoutSummaryTotal', money(total))
      text('checkoutConfirmTotal', money(total))
      renderItems(options.items || [])
      renderDetails(options.details || [])
      receivedInput.value = money(total)
      referenceInput.value = ''
      confirmButton.disabled = false
      selectMethod(methods[0] || null)
      modal.show()
    }
  }
})
